import * as z from "zod";

export const getCreditsYardIntegration = {
  name: "getCreditsYardIntegration" as const,
  input: z.object({}),
  output: z.object({
    creditsYardIntegration: z.optional(z.object({ enabled: z.boolean() })),
  }),
};

export type GetCreditsYardIntegrationOutput = z.infer<
  typeof getCreditsYardIntegration.output
>;
